export default {
  Title: 'Báo cáo nhanh',
  TimeReport: 'Chọn kỳ báo cáo',
  GetData: 'Lấy dữ liệu',
  Group: 'Nhóm theo cột',
  Account: 'Tài khoản',
  GroupTitle: 'Nhóm dữ liệu theo cột',
  ResetBtn: 'Đặt lại',
  ExecuteBtn: 'Thực hiện',
};
